export default __webpack_public_path__ + "static/media/M.Abdullah.a9aa3bbb.png";